import { render, staticRenderFns } from "./WidgetComponent.vue?vue&type=template&id=6fbb5c11&scoped=true"
import script from "./WidgetComponent.vue?vue&type=script&lang=js"
export * from "./WidgetComponent.vue?vue&type=script&lang=js"
import style0 from "./WidgetComponent.vue?vue&type=style&index=0&id=6fbb5c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb5c11",
  null
  
)

export default component.exports